import { render, staticRenderFns } from "./AgreementModal.vue?vue&type=template&id=6c97a0a8&scoped=true"
import script from "./AgreementModal.vue?vue&type=script&lang=js"
export * from "./AgreementModal.vue?vue&type=script&lang=js"
import style0 from "./AgreementModal.vue?vue&type=style&index=0&id=6c97a0a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c97a0a8",
  null
  
)

export default component.exports